import { createUseStyles } from 'react-jss';

const styles = {
  modal: {
    padding: '3rem 2.4rem 0',
    maxWidth: '80%',
    maxHeight: '85vh',
    marginTop: '6.5rem',
    position: 'relative',
    '& > div:last-child': {
      width: '100%',
      margin: '0 auto',
    },
  },
  proposalContent: {
    '& section': {
      maxWidth: '100%',
      boxShadow: 'none',
      width: '100%',
      position: 'static',
      minHeight: '75vh',
    },
    '& h2': {
      marginTop: 0,
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
